import CsvTableWidget, { CSVTableMetadata } from '@/components/CsvTableWidget';
import FilesWidget from '@/components/FilesWidget';
import PremiumWidgetDenied from '@/features/Dashboard/components/PremiumWidgetDenied';
import useIsPremiumAccess from '@/hooks/useIsPremiumAccess';
import ChartsBlock from '@/pages/Markets/MarketsComponents/Chart';
import CommoditiesTable from '@/pages/Markets/MarketsComponents/CommoditiesTable';
import Index from '@/pages/Markets/MarketsComponents/components/CustomChart';
import { Feed } from '@/pages/Markets/MarketsComponents/Feed';
import { FeedFilters } from '@/pages/Markets/MarketsComponents/Feed/api/fetchFeedData';
import { LightModeProvider } from '@/pages/Markets/MarketsComponents/LightMode/contexts/LightModeContext';
import MiniTablesContainer from '@/pages/Markets/MarketsComponents/MiniTablesContainer';
import { BaseTabType } from '@/slices/marketsSlice';

export const MarketWidget = ({ tab }: { tab: BaseTabType }) => {
  const isPremiumAccessGranted = useIsPremiumAccess();

  switch (tab.type) {
    case 'table':
      return (
        <CommoditiesTable
          key={tab.id}
          layout={tab.layout}
          sections={tab.sections}
        />
      );
    case 'graph':
      if (!isPremiumAccessGranted) {
        return <PremiumWidgetDenied />;
      }
      if (tab?.metadata?.graphType === 'custom') {
        return (
          <Index
            key={tab.id}
            layout={tab.layout}
            metadata={tab.metadata}
          />
        );
      }
      return (
        <LightModeProvider>
          <ChartsBlock
            key={tab.id}
            layout={tab.layout}
            tab={tab}
          />
        </LightModeProvider>
      );

    case 'feed':
      return (
        <Feed
          key={tab.id}
          metadata={tab.metadata as FeedFilters}
        />
      );

    case 'minitable':
      return <MiniTablesContainer tables={tab.tables} />;
    case 'csvtable':
      return (
        <CsvTableWidget
          fileName={tab.fileName}
          groupName={tab.groupName}
          layout={tab.layout}
          metadata={tab.metadata as CSVTableMetadata}
        />
      );
    case 'file_list':
      return (
        <FilesWidget
          downloadable={tab.metadata?.downloadable as any}
          groupName={tab.groupName as any}
          size={tab.size as any}
        />
      );
    default:
      return null;
  }
};
